import { faPowerOff } from "@fortawesome/pro-light-svg-icons"

import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { SuccessDisplay } from "../../../../../core/api/errorTypes"
import { ActionBarMenu, ActionBarMenuItem } from "../../../../../shared/components/table/FloatingActionBar"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

import { MerchantProductsQuery, updateProductsStatus } from "../productsApi"

type ProductsStatusActionBarMenuProps = Readonly<{
    productIds: ReadonlyArray<number>
    onStatusUpdated: () => void
}>

export function ProductsStatusActionBarMenu({ productIds, onStatusUpdated }: ProductsStatusActionBarMenuProps) {
    const { mutate: setProductsStatus, isLoading } = useApiMutation(updateProductsStatus, {
        successDisplay: SuccessDisplay.SNACKBAR,
        async onSuccess(_params, _data, context) {
            await context.queryClient.invalidateQueries({ queryKey: [MerchantProductsQuery.LIST] })
            onStatusUpdated()
        },
    })

    return (
        <LocalizedStrict id="products-action-bar-status" attrs={{ title: true }}>
            <ActionBarMenu icon={faPowerOff} title="Status" isLoading={isLoading}>
                <LocalizedStrict id="products-action-bar-set-active" attrs={{ title: true }}>
                    <ActionBarMenuItem
                        title="Active"
                        onClick={() => setProductsStatus({ isActive: true, productIds })}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="products-action-bar-set-inactive" attrs={{ title: true }}>
                    <ActionBarMenuItem
                        title="Inactive"
                        onClick={() => setProductsStatus({ isActive: false, productIds })}
                    />
                </LocalizedStrict>
            </ActionBarMenu>
        </LocalizedStrict>
    )
}
